<template>
  <div class="content">
    <form>
      <refund-form :datas="dataall"></refund-form>
      <kontragent :datas="dataall"></kontragent>
      <firma></firma>
      <sklad :datas="dataall"></sklad>
      <paytype :datas="dataall"></paytype>
    </form>
  </div>
</template>
<script>
import { RefundForm, Kontragent, Sklad, Firma, Paytype } from "@/pages";
export default {
  components: {
    RefundForm,
    Kontragent,
    Sklad,
    Firma,
    Paytype
  },
  watch: {
    dataall: {
      deep: true,
      handler(val, oldVal) {
        this.$store.state.saved += 1;
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    if (this.$store.state.saved <3) {
      this.$store.state.saved = null;
      next();
    } else {
      const answer = window.confirm(
        this.$t("Sizda saqlanmagan malumotlar mavjud. Saqlansinmi?")
      );
      if (answer) {
        this.$root.$refs.refund.Savedokument();
      } else {
        this.$store.state.saved = null;
        next();
      }
    }
  },
  data() {
    return {
      watch: false,
      update_password: "",
      dataall: {}
    };
  },
  created:function(){
    this.Data();
  },
  methods: {
    Data() {
      let self = this;
      axios
        .get("api/v1/refund/id/" + self.$route.params.id, {})
        .then(function(response) {
          self.dataall = response.data;
          self.$store.state.saved=null;
        });
    }
  }
};
</script>
